export default __webpack_public_path__ + "static/media/real-estate-property-analytics-logo-transparent.46639509.png";